// extracted by mini-css-extract-plugin
module.exports = {"grid":"AllCourcesStyle_grid__2Y18M","card":"AllCourcesStyle_card__2iUWU","detail":"AllCourcesStyle_detail__m-ZZd"};